import React from "react";
import { SelectFieldWrapper } from '../styles';
import { Box } from '@mui/material';
import { Spinner } from 'shared/ui/Loader/styles';

interface IFieldGroupProps {
	label?: string;
	children?: React.ReactNode;
	tooltipDescription?: string;
	loading?: boolean;
}

const FieldGroup = ({ label, children, loading }: IFieldGroupProps) => {
	return (
		<SelectFieldWrapper>
			<Box display="flex" mb={2} alignItems="center" position="relative" sx={{backgroundColor: 'background.default'}}>
				<label>{label}</label>
				{loading && <Spinner size="20px" sx={{ marginLeft: 'auto' }}/>}
			</Box>
			{children}
		</SelectFieldWrapper>
	);
};

export default FieldGroup;
